var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIconNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 116.989,
    viewBox: "0 0 130 116.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_176976",
    "data-name": "Group 176976",
    transform: "translate(12007 10442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145101",
    "data-name": "Rectangle 145101",
    width: 130,
    height: 100,
    transform: "translate(-12007 -10442)",
    fill: "#c50f3c",
    opacity: 0.005
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176973",
    "data-name": "Group 176973",
    transform: "translate(-12007 -10442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30000",
    "data-name": "Path 30000",
    d: "M-22.08,0V-7.608h-3.072V-8.46h7.14v.852h-3.072V0Zm6.732.108A2.939,2.939,0,0,1-17.532-.7a2.988,2.988,0,0,1-.8-2.2,3.388,3.388,0,0,1,.36-1.59,2.636,2.636,0,0,1,.99-1.068,2.779,2.779,0,0,1,1.458-.378,2.351,2.351,0,0,1,1.86.762A3.056,3.056,0,0,1-13-3.084v.372h-4.392a2.2,2.2,0,0,0,.576,1.518,1.992,1.992,0,0,0,1.464.522A3.131,3.131,0,0,0-14.34-.834a2.741,2.741,0,0,0,.912-.534l.336.684A2.754,2.754,0,0,1-14.1-.1,3.82,3.82,0,0,1-15.348.108ZM-15.5-5.22a1.7,1.7,0,0,0-1.308.516,2.257,2.257,0,0,0-.564,1.356h3.54a2.184,2.184,0,0,0-.462-1.38A1.509,1.509,0,0,0-15.5-5.22ZM-11.568,0V-5.832h.948v.984a1.923,1.923,0,0,1,.732-.81A2.075,2.075,0,0,1-8.8-5.94,1.65,1.65,0,0,1-7.044-4.752a2.028,2.028,0,0,1,.78-.87A2.218,2.218,0,0,1-5.076-5.94q1.944,0,1.944,2.3V0H-4.1V-3.588A1.986,1.986,0,0,0-4.386-4.77a1.085,1.085,0,0,0-.93-.378,1.393,1.393,0,0,0-1.128.5A2.032,2.032,0,0,0-6.864-3.3V0h-.972V-3.588A1.986,1.986,0,0,0-8.118-4.77a1.085,1.085,0,0,0-.93-.378,1.389,1.389,0,0,0-1.134.5A2.052,2.052,0,0,0-10.6-3.3V0ZM-1.32,2.16V-5.832h.948v1.044a1.958,1.958,0,0,1,.786-.846A2.364,2.364,0,0,1,1.632-5.94a2.5,2.5,0,0,1,1.362.366,2.4,2.4,0,0,1,.9,1.044,3.772,3.772,0,0,1,.318,1.614,3.741,3.741,0,0,1-.318,1.6,2.442,2.442,0,0,1-.9,1.05A2.474,2.474,0,0,1,1.632.108a2.386,2.386,0,0,1-1.2-.3,1.856,1.856,0,0,1-.78-.828V2.16ZM1.428-.672a1.627,1.627,0,0,0,1.308-.582,2.5,2.5,0,0,0,.492-1.662,2.5,2.5,0,0,0-.492-1.668A1.634,1.634,0,0,0,1.428-5.16,1.634,1.634,0,0,0,.12-4.584,2.5,2.5,0,0,0-.372-2.916,2.5,2.5,0,0,0,.12-1.254,1.627,1.627,0,0,0,1.428-.672Zm6.036.78A1.67,1.67,0,0,1,6.126-.414a2.263,2.263,0,0,1-.45-1.518V-8.46h.972V-2q0,1.284,1.02,1.284a1.877,1.877,0,0,0,.54-.072L8.184.024A3.266,3.266,0,0,1,7.464.108Zm3.6,0A2.394,2.394,0,0,1,9.99-.126a1.9,1.9,0,0,1-.75-.642,1.591,1.591,0,0,1-.276-.912,1.464,1.464,0,0,1,.33-1.008,1.972,1.972,0,0,1,1.092-.534,10.493,10.493,0,0,1,2.082-.162h.384v-.372a1.552,1.552,0,0,0-.306-1.074,1.278,1.278,0,0,0-.978-.33,3.478,3.478,0,0,0-1.02.15,4,4,0,0,0-1.008.486L9.2-5.232a3.7,3.7,0,0,1,1.11-.516,4.449,4.449,0,0,1,1.254-.192,2.264,2.264,0,0,1,1.674.552,2.357,2.357,0,0,1,.546,1.716V0h-.912V-1.008a1.811,1.811,0,0,1-.7.816A2.031,2.031,0,0,1,11.064.108Zm.156-.732a1.522,1.522,0,0,0,1.176-.5,1.8,1.8,0,0,0,.456-1.266v-.36H12.48a10.121,10.121,0,0,0-1.53.09,1.424,1.424,0,0,0-.78.312.819.819,0,0,0-.222.606,1.039,1.039,0,0,0,.342.8A1.327,1.327,0,0,0,11.22-.624Zm6.708.732A2.033,2.033,0,0,1,16.38-.438a2.212,2.212,0,0,1-.516-1.578v-3.06h-1.14v-.756h1.14V-7.62h.972v1.788h1.848v.756H16.836v2.964a1.613,1.613,0,0,0,.288,1.038,1.138,1.138,0,0,0,.936.354,1.578,1.578,0,0,0,.384-.048q.192-.048.348-.1l.168.744A1.973,1.973,0,0,1,18.5.036,2.467,2.467,0,0,1,17.928.108Zm4.428,0A2.939,2.939,0,0,1,20.172-.7a2.988,2.988,0,0,1-.8-2.2,3.388,3.388,0,0,1,.36-1.59,2.636,2.636,0,0,1,.99-1.068,2.779,2.779,0,0,1,1.458-.378,2.351,2.351,0,0,1,1.86.762,3.056,3.056,0,0,1,.672,2.094v.372H20.316a2.2,2.2,0,0,0,.576,1.518,1.992,1.992,0,0,0,1.464.522,3.131,3.131,0,0,0,1.008-.162,2.741,2.741,0,0,0,.912-.534l.336.684A2.754,2.754,0,0,1,23.6-.1,3.82,3.82,0,0,1,22.356.108ZM22.2-5.22a1.7,1.7,0,0,0-1.308.516,2.257,2.257,0,0,0-.564,1.356h3.54a2.184,2.184,0,0,0-.462-1.38A1.509,1.509,0,0,0,22.2-5.22Z",
    transform: "translate(65 63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(53.078 17.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2347",
    "data-name": "Path 2347",
    transform: "translate(-0.15 -0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21061",
    "data-name": "Path 21061",
    d: "M1.169,1.37V5.48h21.04V1.37H1.169m0-1.37h21.04a1.21,1.21,0,0,1,1.169,1.37V6.576a.276.276,0,0,1-.234.274H.234A.276.276,0,0,1,0,6.576V1.37A1.21,1.21,0,0,1,1.169,0Z",
    transform: "translate(0.383 0.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21061_-_Outline",
    "data-name": "Path 21061 - Outline",
    d: "M1.353-.15H22.491a1.571,1.571,0,0,1,1.5,1.753V6.809a.632.632,0,0,1-.563.657H.413A.632.632,0,0,1-.15,6.809V1.6A1.571,1.571,0,0,1,1.353-.15ZM23.337,6.7V1.6c0-.609-.324-.987-.846-.987H1.353C.831.616.507.994.507,1.6V6.7ZM1.024,1.22h21.8V6.1H1.024Zm21.138.766H1.681V5.33H22.163Z",
    transform: "translate(0.15 0.15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2348",
    "data-name": "Path 2348",
    transform: "translate(5.417 5.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21062",
    "data-name": "Path 21062",
    d: "M23.256,23.941H7.5V7.5H23.941V23.256A.618.618,0,0,1,23.256,23.941Z",
    transform: "translate(-6.432 -6.432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21062_-_Outline",
    "data-name": "Path 21062 - Outline",
    d: "M23.489,24.557H7.35V7.35H24.557V23.489A1,1,0,0,1,23.489,24.557ZM8.116,23.791H23.489c.229,0,.3-.073.3-.3V8.116H8.116Z",
    transform: "translate(-6.665 -6.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21063",
    "data-name": "Path 21063",
    d: "M8.37,8.37V23.441H23.441V8.37H8.37M7.274,7H24.537a.3.3,0,0,1,.274.274V23.441a1.294,1.294,0,0,1-1.37,1.37H7.274A.3.3,0,0,1,7,24.537V7.274A.3.3,0,0,1,7.274,7Z",
    transform: "translate(-6.617 -6.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21063_-_Outline",
    "data-name": "Path 21063 - Outline",
    d: "M7.507,6.85H24.77a.674.674,0,0,1,.657.657V23.674a1.677,1.677,0,0,1-1.753,1.753H7.507a.674.674,0,0,1-.657-.657V7.507A.674.674,0,0,1,7.507,6.85Zm17.154.766H7.616V24.661H23.674a.916.916,0,0,0,.987-.987ZM8.22,8.22H24.057V24.057H8.22Zm15.071.766H8.986v14.3h14.3Z",
    transform: "translate(-6.85 -6.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2349",
    "data-name": "Path 2349",
    transform: "translate(-0.15 5.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21064",
    "data-name": "Path 21064",
    d: "M5.98,23.941h-4.8A.618.618,0,0,1,.5,23.256V7.5H5.98Z",
    transform: "translate(0.568 -6.432)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21064_-_Outline",
    "data-name": "Path 21064 - Outline",
    d: "M6.6,24.557H1.418A1,1,0,0,1,.35,23.489V7.35H6.6ZM1.116,8.116V23.489c0,.229.073.3.3.3H5.83V8.116Z",
    transform: "translate(0.335 -6.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21065",
    "data-name": "Path 21065",
    d: "M1.37,8.37V23.441H5.48V8.37H1.37M.274,7h6.3a.3.3,0,0,1,.274.274V24.537a.3.3,0,0,1-.274.274H1.37A1.294,1.294,0,0,1,0,23.441V7.274A.3.3,0,0,1,.274,7Z",
    transform: "translate(0.383 -6.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21065_-_Outline",
    "data-name": "Path 21065 - Outline",
    d: "M.507,6.85h6.3a.674.674,0,0,1,.657.657V24.77a.674.674,0,0,1-.657.657H1.6A1.677,1.677,0,0,1-.15,23.674V7.507A.674.674,0,0,1,.507,6.85ZM6.7,7.616H.616V23.674a.916.916,0,0,0,.987.987H6.7Zm-5.48.6H6.1V24.057H1.22Zm4.11.766H1.986v14.3H5.33Z",
    transform: "translate(0.15 -6.85)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29176",
    "data-name": "Path 29176",
    d: "M2.092,0H23.013L0,23.013V2.092A2.092,2.092,0,0,1,2.092,0Z",
    transform: "translate(-11942 -10357.557) rotate(45)",
    fill: "#fff",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIconNoBg);
export default __webpack_public_path__ + "static/media/templateIconNoBg.41eedc7db4bc7f98842bb8f4cb1d16ea.svg";
export { ForwardRef as ReactComponent };